import { render, staticRenderFns } from "./odd-create-helper.vue?vue&type=template&id=3cb52a46"
import script from "./odd-create-helper.vue?vue&type=script&lang=js"
export * from "./odd-create-helper.vue?vue&type=script&lang=js"
import style0 from "./odd-create-helper.vue?vue&type=style&index=0&id=3cb52a46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports